export default __webpack_public_path__ + "static/bell-d8227b440bdc0de2e9d32b7db143b399.mp3";